import { PanoramicAnalysis } from '../types';

const DENTEX_SOURCE = {
  dataset: 'DENTEX (validation_triple.json)',
  url: 'https://huggingface.co/datasets/ibrahimhamamci/DENTEX',
  license: 'CC BY-NC-SA 4.0',
};

export const PANORAMIC_ANALYSIS: PanoramicAnalysis[] = [
  {
    patientId: 'p1',
    model: {
      name: 'HierarchicalDet (DENTEX baseline)',
      reference: 'https://github.com/ibrahimethemhamamci/HierarchicalDet',
    },
    note: 'Sample analysis derived from the public DENTEX dataset (non-commercial research use).',
    studies: [
      {
        id: 'pan-1',
        imageId: 1,
        fileName: 'val_15.png',
        width: 2892,
        height: 1316,
        capturedAt: '2024-11-05',
        source: DENTEX_SOURCE,
        findings: [
          { id: 'pan-1-f1', fdiTooth: '48', quadrant: '4', tooth: '8', diagnosis: 'Impacted', bbox: [657, 606, 242, 204], area: 37377 },
          { id: 'pan-1-f2', fdiTooth: '38', quadrant: '3', tooth: '8', diagnosis: 'Impacted', bbox: [2070, 655, 231, 195], area: 35904 },
          { id: 'pan-1-f3', fdiTooth: '18', quadrant: '1', tooth: '8', diagnosis: 'Impacted', bbox: [815, 259, 209, 217], area: 31554 },
          { id: 'pan-1-f4', fdiTooth: '46', quadrant: '4', tooth: '6', diagnosis: 'Caries', bbox: [987, 619, 200, 270], area: 38380 },
          { id: 'pan-1-f5', fdiTooth: '16', quadrant: '1', tooth: '6', diagnosis: 'Caries', bbox: [1007, 315, 152, 291], area: 35046 },
          { id: 'pan-1-f6', fdiTooth: '36', quadrant: '3', tooth: '6', diagnosis: 'Caries', bbox: [1804, 635, 210, 295], area: 41056 },
        ],
      },
    ],
  },
  {
    patientId: 'p2',
    model: {
      name: 'HierarchicalDet (DENTEX baseline)',
      reference: 'https://github.com/ibrahimethemhamamci/HierarchicalDet',
    },
    note: 'Sample analysis derived from the public DENTEX dataset (non-commercial research use).',
    studies: [
      {
        id: 'pan-2',
        imageId: 2,
        fileName: 'val_38.png',
        width: 2942,
        height: 1316,
        capturedAt: '2024-10-21',
        source: DENTEX_SOURCE,
        findings: [
          { id: 'pan-2-f1', fdiTooth: '48', quadrant: '4', tooth: '8', diagnosis: 'Impacted', bbox: [696, 643, 243, 252], area: 44461 },
          { id: 'pan-2-f2', fdiTooth: '18', quadrant: '1', tooth: '8', diagnosis: 'Impacted', bbox: [923, 316, 235, 244], area: 40692 },
          { id: 'pan-2-f3', fdiTooth: '38', quadrant: '3', tooth: '8', diagnosis: 'Impacted', bbox: [2001, 638, 254, 229], area: 39004 },
          { id: 'pan-2-f4', fdiTooth: '28', quadrant: '2', tooth: '8', diagnosis: 'Impacted', bbox: [1821, 336, 189, 229], area: 33720 },
          { id: 'pan-2-f5', fdiTooth: '35', quadrant: '3', tooth: '5', diagnosis: 'Periapical Lesion', bbox: [1671, 757, 315, 395], area: 54295 },
        ],
      },
    ],
  },
  {
    patientId: 'p3',
    model: {
      name: 'HierarchicalDet (DENTEX baseline)',
      reference: 'https://github.com/ibrahimethemhamamci/HierarchicalDet',
    },
    note: 'Sample analysis derived from the public DENTEX dataset (non-commercial research use).',
    studies: [
      {
        id: 'pan-3',
        imageId: 3,
        fileName: 'val_33.png',
        width: 2987,
        height: 1316,
        capturedAt: '2024-09-18',
        source: DENTEX_SOURCE,
        findings: [
          { id: 'pan-3-f1', fdiTooth: '17', quadrant: '1', tooth: '7', diagnosis: 'Deep Caries', bbox: [1049, 400, 126, 273], area: 25967 },
          { id: 'pan-3-f2', fdiTooth: '16', quadrant: '1', tooth: '6', diagnosis: 'Caries', bbox: [1151, 410, 110, 271], area: 21937 },
          { id: 'pan-3-f3', fdiTooth: '34', quadrant: '3', tooth: '4', diagnosis: 'Caries', bbox: [1655, 749, 113, 251], area: 19084 },
          { id: 'pan-3-f4', fdiTooth: '36', quadrant: '3', tooth: '6', diagnosis: 'Caries', bbox: [1757.7419354838707, 696.8387096774193, 237, 276], area: 39057 },
          { id: 'pan-3-f5', fdiTooth: '26', quadrant: '2', tooth: '6', diagnosis: 'Caries', bbox: [1774, 425, 132, 278], area: 25578 },
          { id: 'pan-3-f6', fdiTooth: '44', quadrant: '4', tooth: '4', diagnosis: 'Caries', bbox: [1239.240506329114, 730.379746835443, 111.39240506329111, 269.62025316455697], area: 19775 },
        ],
      },
    ],
  },
];
